// export const languageMap = {
//     'en': '英语',
// }
export const packageShapeOpts = [
    { label: '不规则形状', value: 0 },
    { label: '长方体', value: 1 },
    { label: '圆柱体', value: 2 },
]
export const packageTypeOpts = [
    { label: '硬包装', value: 0 },
    { label: '软包装+硬物', value: 1 },
    { label: '软包装+软物', value: 2 },
]
export const technologyTypeOpts = [
    { label: '单一工艺', value: '1' },
    { label: '组合工艺', value: '2' }
]
export const technologyMap = {
    "1": [
        {
            "id": 10001,
            "name": "基础工艺",
            "childDetail": []
        },
        {
            "id": 10002,
            "name": "木制品定制工艺",
            "childDetail": [
                {
                    "id": 20001,
                    "name": "激光雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20002,
                    "name": "激光雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20003,
                    "name": "机械雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20004,
                    "name": "机械雕刻-图片",
                    "childDetail": null
                }
            ]
        },
        {
            "id": 10003,
            "name": "金属制品定制工艺",
            "childDetail": [
                {
                    "id": 20001,
                    "name": "激光雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20002,
                    "name": "激光雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20003,
                    "name": "机械雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20004,
                    "name": "机械雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20005,
                    "name": "焊接",
                    "childDetail": null
                },
                {
                    "id": 20006,
                    "name": "蚀刻",
                    "childDetail": null
                },
                {
                    "id": 20007,
                    "name": "UV",
                    "childDetail": null
                },
                {
                    "id": 20008,
                    "name": "丝网印刷-文字",
                    "childDetail": null
                },
                {
                    "id": 20009,
                    "name": "丝网印刷-图片",
                    "childDetail": null
                },
                {
                    "id": 20010,
                    "name": "喷漆",
                    "childDetail": null
                },
                {
                    "id": 20011,
                    "name": "滴油",
                    "childDetail": null
                },
                {
                    "id": 20012,
                    "name": "滴胶-文字",
                    "childDetail": null
                },
                {
                    "id": 20013,
                    "name": "滴胶-图片",
                    "childDetail": null
                },
                {
                    "id": 20014,
                    "name": "激光切割-文字",
                    "childDetail": null
                },
                {
                    "id": 20015,
                    "name": "激光切割-图片",
                    "childDetail": null
                },
                {
                    "id": 20016,
                    "name": "镶钻",
                    "childDetail": null
                },
                {
                    "id": 20024,
                    "name": "电镀",
                    "childDetail": null
                }
            ]
        },
        {
            "id": 10004,
            "name": "皮具/布艺定制工艺",
            "childDetail": [
                {
                    "id": 20001,
                    "name": "激光雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20002,
                    "name": "激光雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20007,
                    "name": "UV",
                    "childDetail": null
                },
                {
                    "id": 20008,
                    "name": "丝网印刷-文字",
                    "childDetail": null
                },
                {
                    "id": 20009,
                    "name": "丝网印刷-图片",
                    "childDetail": null
                },
                {
                    "id": 20011,
                    "name": "滴油",
                    "childDetail": null
                },
                {
                    "id": 20012,
                    "name": "滴胶-文字",
                    "childDetail": null
                },
                {
                    "id": 20013,
                    "name": "滴胶-图片",
                    "childDetail": null
                },
                {
                    "id": 20017,
                    "name": "烫金-文字",
                    "childDetail": null
                },
                {
                    "id": 20018,
                    "name": "烫金-图片",
                    "childDetail": null
                },
                {
                    "id": 20019,
                    "name": "锡金",
                    "childDetail": null
                },
                {
                    "id": 20020,
                    "name": "热转印-文字",
                    "childDetail": null
                },
                {
                    "id": 20021,
                    "name": "热转印-图片",
                    "childDetail": null
                },
                {
                    "id": 20022,
                    "name": "刺绣",
                    "childDetail": null
                },
                {
                    "id": 20023,
                    "name": "植绒",
                    "childDetail": null
                },
                {
                    "id": 20025,
                    "name": "烫画-文字",
                    "childDetail": null
                },
                {
                    "id": 20026,
                    "name": "烫画-图片",
                    "childDetail": null
                },
                {
                    "id": 20027,
                    "name": "数码直喷",
                    "childDetail": null
                },
                {
                    "id": 20033,
                    "name": "压印",
                    "childDetail": null
                },
                {
                    "id": 20035,
                    "name": "机织图案-胶贴",
                    "childDetail": null
                }
            ]
        },
        {
            "id": 10005,
            "name": "有机材料（亚克力/树脂等）定制工艺",
            "childDetail": [
                {
                    "id": 20001,
                    "name": "激光雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20002,
                    "name": "激光雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20003,
                    "name": "机械雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20004,
                    "name": "机械雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20007,
                    "name": "UV",
                    "childDetail": null
                },
                {
                    "id": 20008,
                    "name": "丝网印刷-文字",
                    "childDetail": null
                },
                {
                    "id": 20009,
                    "name": "丝网印刷-图片",
                    "childDetail": null
                },
                {
                    "id": 20014,
                    "name": "激光切割-文字",
                    "childDetail": null
                },
                {
                    "id": 20015,
                    "name": "激光切割-图片",
                    "childDetail": null
                },
                {
                    "id": 20034,
                    "name": "美甲手绘",
                    "childDetail": null
                }
            ]
        },
        {
            "id": 10006,
            "name": "画布/纸张定制工艺",
            "childDetail": [
                {
                    "id": 20028,
                    "name": "手绘-素描",
                    "childDetail": null
                },
                {
                    "id": 20029,
                    "name": "手绘-水彩",
                    "childDetail": null
                },
                {
                    "id": 20030,
                    "name": "手绘-油画",
                    "childDetail": null
                },
                {
                    "id": 20031,
                    "name": "手绘-版画",
                    "childDetail": null
                },
                {
                    "id": 20032,
                    "name": "手绘-漫画",
                    "childDetail": null
                },
                {
                    "id": 20033,
                    "name": "压印",
                    "childDetail": null
                }
            ]
        }
    ],
    "2": [
        {
            "id": 10002,
            "name": "木制品定制工艺",
            "childDetail": [
                {
                    "id": 20001,
                    "name": "激光雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20002,
                    "name": "激光雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20003,
                    "name": "机械雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20004,
                    "name": "机械雕刻-图片",
                    "childDetail": null
                }
            ]
        },
        {
            "id": 10003,
            "name": "金属制品定制工艺",
            "childDetail": [
                {
                    "id": 20001,
                    "name": "激光雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20002,
                    "name": "激光雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20003,
                    "name": "机械雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20004,
                    "name": "机械雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20005,
                    "name": "焊接",
                    "childDetail": null
                },
                {
                    "id": 20007,
                    "name": "UV",
                    "childDetail": null
                },
                {
                    "id": 20008,
                    "name": "丝网印刷-文字",
                    "childDetail": null
                },
                {
                    "id": 20009,
                    "name": "丝网印刷-图片",
                    "childDetail": null
                },
                {
                    "id": 20010,
                    "name": "喷漆",
                    "childDetail": null
                },
                {
                    "id": 20011,
                    "name": "滴油",
                    "childDetail": null
                },
                {
                    "id": 20014,
                    "name": "激光切割-文字",
                    "childDetail": null
                },
                {
                    "id": 20015,
                    "name": "激光切割-图片",
                    "childDetail": null
                },
                {
                    "id": 20016,
                    "name": "镶钻",
                    "childDetail": null
                },
                {
                    "id": 20024,
                    "name": "电镀",
                    "childDetail": null
                }
            ]
        },
        {
            "id": 10004,
            "name": "皮具/布艺定制工艺",
            "childDetail": [
                {
                    "id": 20001,
                    "name": "激光雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20002,
                    "name": "激光雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20007,
                    "name": "UV",
                    "childDetail": null
                },
                {
                    "id": 20008,
                    "name": "丝网印刷-文字",
                    "childDetail": null
                },
                {
                    "id": 20009,
                    "name": "丝网印刷-图片",
                    "childDetail": null
                },
                {
                    "id": 20011,
                    "name": "滴油",
                    "childDetail": null
                },
                {
                    "id": 20017,
                    "name": "烫金-文字",
                    "childDetail": null
                },
                {
                    "id": 20018,
                    "name": "烫金-图片",
                    "childDetail": null
                },
                {
                    "id": 20033,
                    "name": "压印",
                    "childDetail": null
                }
            ]
        },
        {
            "id": 10005,
            "name": "有机材料（亚克力/树脂等）定制工艺",
            "childDetail": [
                {
                    "id": 20001,
                    "name": "激光雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20002,
                    "name": "激光雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20003,
                    "name": "机械雕刻-文字",
                    "childDetail": null
                },
                {
                    "id": 20004,
                    "name": "机械雕刻-图片",
                    "childDetail": null
                },
                {
                    "id": 20007,
                    "name": "UV",
                    "childDetail": null
                },
                {
                    "id": 20008,
                    "name": "丝网印刷-文字",
                    "childDetail": null
                },
                {
                    "id": 20009,
                    "name": "丝网印刷-图片",
                    "childDetail": null
                },
                {
                    "id": 20014,
                    "name": "激光切割-文字",
                    "childDetail": null
                },
                {
                    "id": 20015,
                    "name": "激光切割-图片",
                    "childDetail": null
                }
            ]
        },
        {
            "id": 10006,
            "name": "画布/纸张定制工艺",
            "childDetail": [
                {
                    "id": 20008,
                    "name": "丝网印刷-文字",
                    "childDetail": null
                },
                {
                    "id": 20009,
                    "name": "丝网印刷-图片",
                    "childDetail": null
                },
                {
                    "id": 20017,
                    "name": "烫金-文字",
                    "childDetail": null
                },
                {
                    "id": 20018,
                    "name": "烫金-图片",
                    "childDetail": null
                },
                {
                    "id": 20033,
                    "name": "压印",
                    "childDetail": null
                }
            ]
        }
    ]
}

export const isSensitiveOpts = [
    { label: '否', value: 0 },
    { label: '是', value: 1 },
]
export const sensitiveTypesOpts = [
    { label: '纯电', value: 1 },
    { label: '内电', value: 2 },
    { label: '磁性', value: 3 },
    { label: '液体', value: 4 },
    { label: '粉末', value: 5 },
    { label: '膏体', value: 6 },
    { label: '刀具', value: 7 },
]
export const skuClassificationOpts = [
    { label: '单品', value: 1 },
    { label: '同款多件装', value: 2 },
    { label: '混合套装', value: 3 },
]
export const pieceUnitCodeOpts = [
    { label: '件', value: 1 },
    { label: '双', value: 2 },
    { label: '包', value: 3 },
]
export const individuallyPackedOpts = [
    { label: '是独立包装', value: 1 },
    { label: '不是独立包装', value: 0 },
]

export const countryCodes = [
    { name: "中国", code: "CN" },
    { name: "阿富汗", code: "AF" },
    { name: "阿尔巴尼亚", code: "AL" },
    { name: "阿尔及利亚", code: "DZ" },
    { name: "美属萨摩亚", code: "AS" },
    { name: "安道尔", code: "AD" },
    { name: "安哥拉", code: "AO" },
    { name: "安圭拉", code: "AI" },
    { name: "安提瓜和巴布达", code: "AG" },
    { name: "阿根廷", code: "AR" },
    { name: "亚美尼亚", code: "AM" },
    { name: "阿鲁巴", code: "AW" },
    { name: "澳大利亚", code: "AU" },
    { name: "奥地利", code: "AT" },
    { name: "阿塞拜疆", code: "AZ" },
    { name: "巴哈马", code: "BS" },
    { name: "巴林", code: "BH" },
    { name: "孟加拉国", code: "BD" },
    { name: "巴巴多斯", code: "BB" },
    { name: "白俄罗斯", code: "BY" },
    { name: "比利时", code: "BE" },
    { name: "伯利兹", code: "BZ" },
    { name: "贝宁", code: "BJ" },
    { name: "百慕大", code: "BM" },
    { name: "不丹", code: "BT" },
    { name: "玻利维亚", code: "BO" },
    { name: "波黑", code: "BA" },
    { name: "博茨瓦纳", code: "BW" },
    { name: "巴西", code: "BR" },
    { name: "英属印度洋领地", code: "IO" },
    { name: "文莱", code: "BN" },
    { name: "保加利亚", code: "BG" },
    { name: "布基纳法索", code: "BF" },
    { name: "布隆迪", code: "BI" },
    { name: "柬埔寨", code: "KH" },
    { name: "喀麦隆", code: "CM" },
    { name: "加拿大", code: "CA" },
    { name: "佛得角", code: "CV" },
    { name: "开曼群岛", code: "KY" },
    { name: "中非", code: "CF" },
    { name: "乍得", code: "TD" },
    { name: "智利", code: "CL" },
    { name: "中国台湾省", code: "TW" }, // ISO 3166-1标准[6](@ref)
    { name: "中国香港特别行政区", code: "HK" }, // ISO 3166-1标准[6](@ref)
    { name: "中国澳门特别行政区", code: "MO" }, // ISO 3166-1标准[6](@ref)
    { name: "哥伦比亚", code: "CO" },
    { name: "科摩罗", code: "KM" },
    { name: "刚果（布）", code: "CG" },
    { name: "刚果（金）", code: "CD" },
    { name: "库克群岛", code: "CK" },
    { name: "哥斯达黎加", code: "CR" },
    { name: "科特迪瓦", code: "CI" },
    { name: "克罗地亚", code: "HR" },
    { name: "古巴", code: "CU" },
    { name: "塞浦路斯", code: "CY" },
    { name: "捷克", code: "CZ" },
    { name: "丹麦", code: "DK" },
    { name: "吉布提", code: "DJ" },
    { name: "多米尼克", code: "DM" },
    { name: "多米尼加", code: "DO" },
    { name: "厄瓜多尔", code: "EC" },
    { name: "埃及", code: "EG" },
    { name: "萨尔瓦多", code: "SV" },
    { name: "赤道几内亚", code: "GQ" },
    { name: "厄立特里亚", code: "ER" },
    { name: "爱沙尼亚", code: "EE" },
    { name: "斯威士兰", code: "SZ" },
    { name: "埃塞俄比亚", code: "ET" },
    { name: "福克兰群岛", code: "FK" },
    { name: "法罗群岛", code: "FO" },
    { name: "斐济", code: "FJ" },
    { name: "芬兰", code: "FI" },
    { name: "法国", code: "FR" },
    { name: "法属圭亚那", code: "GF" },
    { name: "法属波利尼西亚", code: "PF" },
    { name: "加蓬", code: "GA" },
    { name: "冈比亚", code: "GM" },
    { name: "格鲁吉亚", code: "GE" },
    { name: "德国", code: "DE" },
    { name: "加纳", code: "GH" },
    { name: "直布罗陀", code: "GI" },
    { name: "希腊", code: "GR" },
    { name: "格陵兰", code: "GL" },
    { name: "格林纳达", code: "GD" },
    { name: "瓜德罗普", code: "GP" },
    { name: "关岛", code: "GU" },
    { name: "危地马拉", code: "GT" },
    { name: "根西岛", code: "GG" },
    { name: "几内亚", code: "GN" },
    { name: "几内亚比绍", code: "GW" },
    { name: "圭亚那", code: "GY" },
    { name: "海地", code: "HT" },
    { name: "洪都拉斯", code: "HN" },
    { name: "匈牙利", code: "HU" },
    { name: "冰岛", code: "IS" },
    { name: "印度", code: "IN" },
    { name: "印度尼西亚", code: "ID" },
    { name: "伊朗", code: "IR" },
    { name: "伊拉克", code: "IQ" },
    { name: "爱尔兰", code: "IE" },
    { name: "马恩岛", code: "IM" },
    { name: "以色列", code: "IL" },
    { name: "意大利", code: "IT" },
    { name: "牙买加", code: "JM" },
    { name: "日本", code: "JP" },
    { name: "泽西岛", code: "JE" },
    { name: "约旦", code: "JO" },
    { name: "哈萨克斯坦", code: "KZ" },
    { name: "肯尼亚", code: "KE" },
    { name: "基里巴斯", code: "KI" },
    { name: "朝鲜", code: "KP" },
    { name: "韩国", code: "KR" },
    { name: "科威特", code: "KW" },
    { name: "吉尔吉斯斯坦", code: "KG" },
    { name: "老挝", code: "LA" },
    { name: "拉脱维亚", code: "LV" },
    { name: "黎巴嫩", code: "LB" },
    { name: "莱索托", code: "LS" },
    { name: "利比里亚", code: "LR" },
    { name: "利比亚", code: "LY" },
    { name: "列支敦士登", code: "LI" },
    { name: "立陶宛", code: "LT" },
    { name: "卢森堡", code: "LU" },
    { name: "马达加斯加", code: "MG" },
    { name: "马拉维", code: "MW" },
    { name: "马来西亚", code: "MY" },
    { name: "马尔代夫", code: "MV" },
    { name: "马里", code: "ML" },
    { name: "马耳他", code: "MT" },
    { name: "马绍尔群岛", code: "MH" },
    { name: "马提尼克", code: "MQ" },
    { name: "毛里塔尼亚", code: "MR" },
    { name: "毛里求斯", code: "MU" },
    { name: "马约特", code: "YT" },
    { name: "墨西哥", code: "MX" },
    { name: "密克罗尼西亚", code: "FM" },
    { name: "摩尔多瓦", code: "MD" },
    { name: "摩纳哥", code: "MC" },
    { name: "蒙古", code: "MN" },
    { name: "黑山", code: "ME" },
    { name: "蒙特塞拉特", code: "MS" },
    { name: "摩洛哥", code: "MA" },
    { name: "莫桑比克", code: "MZ" },
    { name: "缅甸", code: "MM" },
    { name: "纳米比亚", code: "NA" },
    { name: "瑙鲁", code: "NR" },
    { name: "尼泊尔", code: "NP" },
    { name: "荷兰", code: "NL" },
    { name: "新喀里多尼亚", code: "NC" },
    { name: "新西兰", code: "NZ" },
    { name: "尼加拉瓜", code: "NI" },
    { name: "尼日尔", code: "NE" },
    { name: "尼日利亚", code: "NG" },
    { name: "纽埃", code: "NU" },
    { name: "诺福克岛", code: "NF" },
    { name: "北马里亚纳群岛", code: "MP" },
    { name: "挪威", code: "NO" },
    { name: "阿曼", code: "OM" },
    { name: "巴基斯坦", code: "PK" },
    { name: "帕劳", code: "PW" },
    { name: "巴勒斯坦", code: "PS" },
    { name: "巴拿马", code: "PA" },
    { name: "巴布亚新几内亚", code: "PG" },
    { name: "巴拉圭", code: "PY" },
    { name: "秘鲁", code: "PE" },
    { name: "菲律宾", code: "PH" },
    { name: "皮特凯恩群岛", code: "PN" },
    { name: "波兰", code: "PL" },
    { name: "葡萄牙", code: "PT" },
    { name: "波多黎各", code: "PR" },
    { name: "卡塔尔", code: "QA" },
    { name: "留尼汪", code: "RE" },
    { name: "罗马尼亚", code: "RO" },
    { name: "俄罗斯", code: "RU" },
    { name: "卢旺达", code: "RW" },
    { name: "圣赫勒拿", code: "SH" },
    { name: "圣基茨和尼维斯", code: "KN" },
    { name: "圣卢西亚", code: "LC" },
    { name: "圣皮埃尔和密克隆", code: "PM" },
    { name: "圣文森特和格林纳丁斯", code: "VC" },
    { name: "萨摩亚", code: "WS" },
    { name: "圣马力诺", code: "SM" },
    { name: "圣多美和普林西比", code: "ST" },
    { name: "沙特阿拉伯", code: "SA" },
    { name: "塞内加尔", code: "SN" },
    { name: "塞尔维亚", code: "RS" },
    { name: "塞舌尔", code: "SC" },
    { name: "塞拉利昂", code: "SL" },
    { name: "新加坡", code: "SG" },
    { name: "斯洛伐克", code: "SK" },
    { name: "斯洛文尼亚", code: "SI" },
    { name: "所罗门群岛", code: "SB" },
    { name: "索马里", code: "SO" },
    { name: "南非", code: "ZA" },
    { name: "南乔治亚和南桑威奇群岛", code: "GS" },
    { name: "南苏丹", code: "SS" },
    { name: "西班牙", code: "ES" },
    { name: "斯里兰卡", code: "LK" },
    { name: "苏丹", code: "SD" },
    { name: "苏里南", code: "SR" },
    { name: "瑞典", code: "SE" },
    { name: "瑞士", code: "CH" },
    { name: "叙利亚", code: "SY" },
    { name: "塔吉克斯坦", code: "TJ" },
    { name: "坦桑尼亚", code: "TZ" },
    { name: "泰国", code: "TH" },
    { name: "东帝汶", code: "TL" },
    { name: "多哥", code: "TG" },
    { name: "托克劳", code: "TK" },
    { name: "汤加", code: "TO" },
    { name: "特立尼达和多巴哥", code: "TT" },
    { name: "突尼斯", code: "TN" },
    { name: "土耳其", code: "TR" },
    { name: "土库曼斯坦", code: "TM" },
    { name: "特克斯和凯科斯群岛", code: "TC" },
    { name: "图瓦卢", code: "TV" },
    { name: "乌干达", code: "UG" },
    { name: "乌克兰", code: "UA" },
    { name: "阿联酋", code: "AE" },
    { name: "英国", code: "GB" },
    { name: "美国", code: "US" },
    { name: "乌拉圭", code: "UY" },
    { name: "乌兹别克斯坦", code: "UZ" },
    { name: "瓦努阿图", code: "VU" },
    { name: "梵蒂冈", code: "VA" },
    { name: "委内瑞拉", code: "VE" },
    { name: "越南", code: "VN" },
    { name: "瓦利斯和富图纳", code: "WF" },
    { name: "也门", code: "YE" },
    { name: "赞比亚", code: "ZM" },
    { name: "津巴布韦", code: "ZW" }
];

export const regionIdOpts = [
    { value: 43000000000002, label: '北京市' },
    { value: 43000000000003, label: '安徽省' },
    { value: 43000000000004, label: '福建省' },
    { value: 43000000000005, label: '甘肃省' },
    { value: 43000000000006, label: '广东省' },
    { value: 43000000000007, label: '广西壮族自治区' },
    { value: 43000000000008, label: '贵州省' },
    { value: 43000000000009, label: '海南省' },
    { value: 43000000000010, label: '河北省' },
    { value: 43000000000011, label: '河南省' },
    { value: 43000000000012, label: '黑龙江省' },
    { value: 43000000000013, label: '湖北省' },
    { value: 43000000000014, label: '湖南省' },
    { value: 43000000000015, label: '吉林省' },
    { value: 43000000000016, label: '江苏省' },
    { value: 43000000000017, label: '江西省' },
    { value: 43000000000018, label: '辽宁省' },
    { value: 43000000000019, label: '内蒙古自治区' },
    { value: 43000000000020, label: '宁夏回族自治区' },
    { value: 43000000000021, label: '青海省' },
    { value: 43000000000022, label: '山东省' },
    { value: 43000000000023, label: '山西省' },
    { value: 43000000000024, label: '陕西省' },
    { value: 43000000000025, label: '上海市' },
    { value: 43000000000026, label: '四川省' },
    { value: 43000000000027, label: '天津市' },
    { value: 43000000000028, label: '西藏自治区' },
    { value: 43000000000029, label: '新疆维吾尔自治区' },
    { value: 43000000000030, label: '云南省' },
    { value: 43000000000031, label: '浙江省' },
    { value: 43000000000032, label: '重庆市' },
    { value: 43000000000033, label: '香港特别行政区' },
    { value: 43000000000034, label: '澳门特别行政区' },
    { value: 43000000000035, label: '台湾省' },
];
// 语种
export const sourceLanguageList = [
    { label:'英语',value:'en' },
    { label:'英语（中东市场）',value:'en2' },
    { label:'英语（英国市场）',value:'en3' },
    { label:'西班牙语',value:'es' },
    { label:'德语',value:'de' },
    { label:'意大利语',value:'it' },
    { label:'法语',value:'fr' },
    { label:'瑞典语',value:'sv' },
    { label:'捷克语',value:'cs' },
    { label:'波兰语',value:'pl' },
    { label:'荷兰语',value:'nl' },
    { label:'日语',value:'ja' },
    { label:'韩语',value:'ko' },
    { label:'阿拉伯语',value:'ar' },
]
// 货币种类
export const CURRENCY_MAP = {
    CNY: { code: 'CNY', symbol: '¥', name: '人民币', precision: 2,format:'#.##' },
    USD: { code: 'USD', symbol: '$', name: '美元', precision: 2,format:'#.##' },
    EUR: { code: 'EUR', symbol: '€', name: '欧元', precision: 2,format:'#.##' },
    GBP: { code: 'GBP', symbol: '£', name: '英镑', precision: 2,format:'#.##' },
    JPY: { code: 'JPY', symbol: '¥', name: '日元', precision: 0,format:'#' },
    KRW: { code: 'KRW', symbol: '₩', name: '韩元', precision: 0,format:'#' },
    SGD: { code: 'SGD', symbol: 'S$', name: '新加坡元', precision: 2,format:'#.##' },
    MYR: { code: 'MYR', symbol: 'RM', name: '马来西亚林吉特', precision: 2,format:'#.##' },
    IDR: { code: 'IDR', symbol: 'Rp', name: '印尼盾', precision: 0,format:'#' },
    VND: { code: 'VND', symbol: '₫', name: '越南盾', precision: 0,format:'#' },
    THB: { code: 'THB', symbol: '฿', name: '泰铢', precision: 2,format:'#.##' },
    PHP: { code: 'PHP', symbol: '₱', name: '菲律宾比索', precision: 2,format:'#.##' },
    AUD: { code: 'AUD', symbol: 'A$', name: '澳大利亚元', precision: 2,format:'#.##' },
    CAD: { code: 'CAD', symbol: 'C$', name: '加拿大元', precision: 2,format:'#.##' },
    HKD: { code: 'HKD', symbol: 'HK$', name: '港币', precision: 2,format:'#.##' },
    TWD: { code: 'TWD', symbol: 'NT$', name: '新台币', precision: 2,format:'#.##' },
}

// 商品产地数据结构
export const getDefaultProductWhExtAttr = () => ({
    productOrigin: {
        region1ShortName: '',
        region2Id: '',
    },
    productOriginCertFiles:[ // 证明文件
        { 
            fileName:'',// 文件名称，需要带文件扩展，eg: test.pdf
            fileUrl:''
        },
    ]
})
// 商品外包装数据结构
export const getDefaultProductOuterPackageInfo = () => ({
  productOuterPackageImages: [],
  productOuterPackage: {
    packageType: 0,
    packageShape: 0,
  },
})
// 模特类型数据 (0-成衣模特，1-鞋模)
export const modelTypeMap = {
    0:{ 
        hipline:'', // 臀围
        bust:'', // 胸围
        waist:'', // 腰围
        height:'' // 身高
    },
    1:{ 
        footLength:'', // 脚长
        footWidth:'', // 脚宽
    }
}
// 模特类型 各字段名称映射
export const modelTypeNameMap = {
    hipline:'臀围',
    bust:'胸围',
    waist:'腰围',
    height:'身高',
    footLength:'脚长',
    footWidth:'脚宽',
}
//模特信息-试穿感受
export const tryOnResultMap = {
    1:'合身',
    2:'偏小',
    3:'偏大',
}

export default {
    // languageMap,
    packageShapeOpts,
    packageTypeOpts,
    countryCodes,
    regionIdOpts,
    technologyTypeOpts,
    technologyMap,
    sensitiveTypesOpts,
    isSensitiveOpts,
    sourceLanguageList,
}
